import { HubBannerViewModel } from '../models/ai-hub.models';

export function buildBanner(iqBoostOn: boolean, isAdmin: boolean): HubBannerViewModel | null {
  if (!iqBoostOn) {
    return {
      messageKey: isAdmin ? 'aiHub.banner.iqBoostOffAdmin' : 'aiHub.banner.iqBoostOffUser',
      iconClass: 'fa-icons icon-solid icon-16 icon-circle-exclamation text-warning-100',
      backgroundClass: 'bg-yellow-10',
    };
  }
  if (!isAdmin) {
    return {
      messageKey: 'aiHub.banner.enabledUser',
      iconClass: 'fa-icons icon-solid icon-16 icon-circle-check text-success',
      backgroundClass: 'bg-bush-green-10',
    };
  }
  return null;
}
